import { useEffect } from 'react'
import { css } from '@emotion/react'
import TextField from '@mui/material/TextField'
import { func, object } from 'prop-types'
import { CvsFilePicker } from '@components'
import { t } from '@lingui/core/macro'

const paddingY = css`
  padding-top: 8px;
  padding-bottom: 8px;
`

export const GoogleDCM = ({
  updatedAccount,
  setUpdatedAccount,
  setRequiredFieldMissing,
  getHelperText,
}) => {
  const checkForDCMErrors = () => {
    setRequiredFieldMissing(
      !updatedAccount.metadata.googleProfileId || !updatedAccount.metadata.googleConnectedEmail,
    )
  }

  useEffect(() => {
    checkForDCMErrors()
  }, [updatedAccount.metadata])

  return (
    <>
      <div>
        <span>{t`This file can be generated in your google cloud account at`}</span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://console.cloud.google.com/apis/credentials/serviceaccountkey"
        >
          https://console.cloud.google.com/apis/credentials/serviceaccountkey
        </a>
        <div css={paddingY}>
          <CvsFilePicker
            onChange={file =>
              setUpdatedAccount(old => ({
                ...old,
                metadata: { ...old.metadata, account_key_file: JSON.parse(file) },
              }))
            }
            fileType=".json"
            fullWidth
          />
        </div>
      </div>
      <div>
        {/* <TextField style={{ width: '100%', marginBottom: 12 }}>
			<label>Upload Service Account Key JSON file</label>
			<md-file
				v-model="googleKeyFile"
				accept=".json"
				change="setGoogleCloudAccountKey"
			/>
		</TextField> */}
      </div>
      <div>
        <TextField
          style={{ width: '100%', marginBottom: 12 }}
          variant="outlined"
          label={t`User Profile ID`}
          required
          value={updatedAccount.metadata.googleProfileId}
          onChange={e => {
            setUpdatedAccount({
              ...updatedAccount,
              metadata: { ...updatedAccount.metadata, googleProfileId: e.target.value },
            })
          }}
          helperText={getHelperText(!updatedAccount.metadata.googleProfileId)}
        />
      </div>
      <div>
        <TextField
          style={{ width: '100%', marginBottom: 12 }}
          variant="outlined"
          label={t`Connected email`}
          required
          value={updatedAccount.metadata.googleConnectedEmail}
          onChange={e => {
            setUpdatedAccount({
              ...updatedAccount,
              metadata: {
                ...updatedAccount.metadata,
                googleConnectedEmail: e.target.value,
              },
            })
          }}
          helperText={getHelperText(!updatedAccount.metadata.googleConnectedEmail)}
        />
      </div>
    </>
  )
}

GoogleDCM.propTypes = {
  updatedAccount: object.isRequired,
  setUpdatedAccount: func.isRequired,
  setRequiredFieldMissing: func.isRequired,
  getHelperText: func.isRequired,
}
